import { canUseDOM } from '@ps/web-core-utils';
import isNil from 'lodash/isNil';
import throttle from 'lodash/throttle';
import { useCallback, useEffect, useState } from 'react';

export enum Orientation {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE'
}

const query = canUseDOM ? window.matchMedia('(orientation: portrait)') : undefined;

const isSupportMatchMedia = Boolean(!isNil(query?.matches));
const isSupportWindowOrientation = Boolean(!isNil(canUseDOM ? window.orientation : undefined));

const getScreenOrientation = () => {
  if (isSupportMatchMedia && query)
    return query.matches ? Orientation.PORTRAIT : Orientation.LANDSCAPE;

  if (isSupportWindowOrientation)
    return Math.abs(window.orientation) === 90 ? Orientation.LANDSCAPE : Orientation.PORTRAIT;

  return undefined;
};

const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState(getScreenOrientation());

  const onHandleChange = useCallback(() => {
    if (!canUseDOM) return;
    return setOrientation(getScreenOrientation());
  }, [setOrientation]);

  useEffect(() => {
    const throttledOnHandleChange = throttle(onHandleChange, 100, { leading: true });

    if (isSupportMatchMedia) {
      query?.addEventListener('change', throttledOnHandleChange);
    } else {
      window.addEventListener('resize', throttledOnHandleChange);
    }
    return () => {
      if (isSupportMatchMedia) {
        query?.removeEventListener('change', throttledOnHandleChange);
      } else {
        window.removeEventListener('resize', throttledOnHandleChange);
      }
    };
  }, [onHandleChange]);

  return orientation;
};

export default useScreenOrientation;
